module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 0